// Restaurant opening hours — Mon=1, Tue=2, ... Sun=0 (JS Date.getDay)
// All times in 24h format. Range can wrap past midnight (close < open => next day).
export const HOURS = {
    1: { open: "12:00", close: "23:30" }, // Monday
    2: { open: "12:00", close: "23:30" },
    3: { open: "12:00", close: "23:30" },
    4: { open: "12:00", close: "23:30" }, // Thursday
    5: { open: "12:00", close: "01:00" }, // Friday (closes 01:00 next day)
    6: { open: "12:00", close: "01:00" }, // Saturday
    0: { open: "12:00", close: "01:00" }, // Sunday
};

const toMin = (hhmm) => {
    const [h, m] = hhmm.split(":").map(Number);
    return h * 60 + m;
};

export function getStoreStatus(now = new Date()) {
    const day = now.getDay();
    const cur = now.getHours() * 60 + now.getMinutes();
    const today = HOURS[day];
    if (!today) return { open: false, label: "Κλειστά", closesAt: null, opensAt: null };

    const openMin = toMin(today.open);
    const closeMin = toMin(today.close);
    // Close past midnight
    const wraps = closeMin <= openMin;

    let isOpen = false;
    if (wraps) {
        isOpen = cur >= openMin || cur < closeMin;
    } else {
        isOpen = cur >= openMin && cur < closeMin;
    }

    if (isOpen) {
        return { open: true, label: "Ανοιχτά τώρα", closesAt: today.close, opensAt: null };
    }

    // find next open day
    for (let i = 1; i <= 7; i++) {
        const d = (day + i) % 7;
        const slot = HOURS[d];
        if (slot) return { open: false, label: "Κλειστά", closesAt: null, opensAt: slot.open };
    }
    return { open: false, label: "Κλειστά", closesAt: null, opensAt: null };
}
